import Button from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Button';
import Spinner from '@johnlewispartnership/wtr-ingredients/dist/ingredients/Spinner';
import { useSearchParams } from 'renderer/hooks/useSearchParams';

import { RECIPE_QUERY_PAGE, RECIPE_QUERY_START_PAGE } from '../constants';
import styles from './RecipePagination.module.scss';

type RecipePaginationProps = {
  isLoading: boolean;
  currentPage: number;
};

const RecipePagination = ({ isLoading, currentPage }: RecipePaginationProps) => {
  const [, setSearchParams] = useSearchParams();

  const handleLoadMore = () => {
    setSearchParams({
      [RECIPE_QUERY_PAGE]: String(currentPage + 1),
      [RECIPE_QUERY_START_PAGE]: '0',
    });
  };

  return (
    <div className={styles.pagination}>
      <Spinner
        isActive={isLoading}
        ariaTextActive="More recipes loading"
        ariaTextInactive="More recipes loaded"
      />
      {!isLoading ? <Button theme="secondary" onClick={handleLoadMore} label="Load more" /> : null}
    </div>
  );
};

export default RecipePagination;
